import Homepage from './Homepage';
import Gallery from './Gallery';
import Watch from './Watch';
import Contact from './Contact';

export default class Page {
    constructor() {
        this.page = null;
        this.initPage();
        window.WK.utilsBus.onPageReady();
    }

    initPage() {
        if (document.querySelector('.js-homepage')) {
            this.page = new Homepage({el: document.querySelector('.js-homepage')});
            return;
        }

        if (document.body.matches('.page-id-162')) {
            this.page = new Gallery({el: document.body});
            return;
        }

        if (document.body.matches('.page-id-160')) {
            this.page = new Watch({el: document.body});
            return;
        }

        if (document.body.matches('.page-id-190')) {
            this.page = new Contact({el: document.body});
            return;
        }
    }
}
